import * as storage from '../../utils/storage';
import { ADD_ONE_SIGNAL_TAGS } from '../../state/mutations/User';
import { OneSignal } from 'react-native-onesignal';
import { client } from '../../config/apollo/client';
import { isWeb } from '../../config/designSystem/Layout';

export const addTag = (key: string, value: string) => {
  if(!isWeb) {
    addTagMobile(key, value);
  } else  {
    addTagWeb(key, value);
  }
};

export const addTagWeb = (key: string, value: string) => {
  addTagsWeb({[key]: value});
};


export const addTagMobile = (key: string, value: string) => {
  OneSignal.User.addTag(key, value);
};


export const addTags = (tags: { [key: string]: string }) => {
  if(!isWeb) {
    addTagsMobile(tags);
  } else {
    addTagsWeb(tags);
  }
};

export const addTagsMobile = (tags: { [key: string]: string }) => {
  OneSignal.User.addTags(tags);
};



export const addTagsWeb = async (tags: { [key: string]: string }) => {
  try {
    // `addTags` is an authenticated mutation and this API permission-filters its
    // schema by role, so calling it without a token fails with the confusing
    // `Cannot query field "addTags" on type "Mutation"` rather than a 401.
    // The register screen calls addTag() on the name field's onBlur - i.e. while
    // the user is still filling the form and no account exists yet - so bail out
    // instead of firing a doomed request. Post-register tagging still happens via
    // setOneSignalUserWeb, which runs once the token is stored.
    const token = await storage.loadString('token');
    if (!token) {
      return;
    }
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const currentDate = Math.round(Number(new Date())/1000);
    const body = JSON.stringify({
      properties: {
        tags,
        timezone_id: timeZone,
        last_active: currentDate
      }
    });
    client.mutate({
      mutation: ADD_ONE_SIGNAL_TAGS,
      variables:{
        body
      }
    });

  }
  catch(error){
    console.log('error',error);
  }
};
